import TeenReviewsWorkspace from "../../../components/reviews/TeenReviewsWorkspace";

const TeenReviewsPage = () => {
  return <TeenReviewsWorkspace />;
};

export default TeenReviewsPage;
